import React from 'react'
import PropTypes from 'prop-types'
import { useTheme } from 'emotion-theming'
import TalentList from './list'
import TalentGrid from './grid'
import { useWindowWidth } from '../../utils/hooks'

const Talent = ({ speakers }) => {
  const { breakpoints } = useTheme()
  const windowWidth = useWindowWidth()
  const isDesktop = windowWidth >= parseInt(breakpoints.medium, 10)

  if (isDesktop) {
    return <TalentGrid speakers={speakers} />
  }

  return <TalentList speakers={speakers} />
}

Talent.propTypes = {
  speakers: PropTypes.arrayOf(
    PropTypes.shape({
      bio: PropTypes.string,
      id: PropTypes.string.isRequired,
      image: PropTypes.string,
      slug: PropTypes.string,
      subtitle: PropTypes.string,
      text: PropTypes.string,
      title: PropTypes.string,
      sort: PropTypes.string,
      events: PropTypes.arrayOf(
        PropTypes.shape({
          EVENTID: PropTypes.string,
          EVENTTITLE: PropTypes.string,
        })
      ),
    })
  ),
}

Talent.defaultProps = {
  speakers: [],
}

export default Talent
